<template>
  <button ref="btn" class="btn btn-outline-info" type="button">
    <i class="fas fa-paperclip"></i>
  </button>
</template>
<script>
import store from "store";
import UserService from "../Services/UserService";

const plupload = require("plupload");
const API = "/upload/save";
const uploaderDefaultOption = {
  runtimes: "html5,html4",
  url: global.API_URI + API,
  filters: [
    { title: "Image", extensions: "jpg,png,jpeg,gif" },
    { title: "Video", extensions: "mp4,mov" },
    { title: "File", extensions: "pdf,zip,docx,doc,xls,xlsx,ppt,pptx" }
  ],
  multi_selection: true
};

export default {
  props: {
    options: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },

  data() {
    return {
      uploader: null
    }
  },

  methods: {
    renderUI: function() {
      let self = this;

      this.$nextTick(() => {
        if (this.uploader) {
          this.uploader.unbindAll();
          this.uploader.destroy();
        }

        let opt = Object.assign(uploaderDefaultOption, self.options, {
          browse_button: self.$refs.btn,

          init: {
            PostInit: function(uploader) {
              self.$emit("init", uploader);
            },

            FilesAdded: function(up, files) {
              up.setOption("headers", {
                Authorization: store.get(UserService.TokenKey)
              });
              self.$emit("added", up, files);
            },

            UploadProgress: function(up, file) {
              self.$emit("progress", up, file);
            },

            FileUploaded: function(up, file, result) {
              self.$emit("uploaded", up, file, result);
            },

            UploadComplete: function (up, files) {
              self.$emit("complete", up, files);
            },

            Error: function(up, err) {
              self.$emit("error", up, err);
            }
          }
        });

        this.uploader = new plupload.Uploader(opt);
        this.uploader.init();
      });
    }
  },

  mounted: function() {
    this.renderUI();
  },
};
</script>
